import React from 'react';
import { Box, Button, SxProps } from '@mui/material';
import { buildDataTestIdAttribute } from '@src/utils';

type ButtonGroupProps = {
  onApply: () => void;
  onCancel: () => void;
  cancelName?: string | React.ReactNode;
  applyName?: string | React.ReactNode;
  sx?: SxProps;
  color?: 'secondary' | 'primary';
  withoutCancel?: boolean;
  withoutApply?: boolean;
  disableApply?: boolean;
  disabled?: boolean;
  dataTestId?: string;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  onApply,
  onCancel,
  cancelName = 'Clear',
  applyName = 'Apply',
  sx,
  color = 'secondary',
  withoutCancel = false,
  withoutApply = false,
  disableApply,
  disabled,
  dataTestId,
}) => {
  return (
    <Box sx={{ marginLeft: 'auto', display: 'flex', justifyContent: 'space-between', ...sx }}>
      {!withoutCancel && (
        <Button
          color={color}
          variant="outlined"
          sx={{ mr: '20px', minWidth: 102 }}
          onClick={onCancel}
          disabled={disabled}
          {...buildDataTestIdAttribute(dataTestId, 'button-cancel')}
        >
          {cancelName}
        </Button>
      )}
      {!withoutApply && (
        <Button
          color={color}
          variant="contained"
          sx={{ minWidth: 102 }}
          onClick={onApply}
          disabled={disableApply || disabled}
          {...buildDataTestIdAttribute(dataTestId, 'button-apply')}
        >
          {applyName}
        </Button>
      )}
    </Box>
  );
};
